// Recovered compiled webpack factory 33778. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  n.d(t, { M0: () => r, ae: () => c, g7: () => u, te: () => i });
  let r = 60,
    i = 200,
    a = ["/sign-in"],
    o = ["session_id", "payment", "sub"],
    s = ["/command", "/command-panel", "/lab"],
    l = (e, t) => t.some((t) => e === t || e.startsWith(`${t}/`));
  function c(e, t) {
    return l(e, a) || o.some((e) => t.has(e));
  }
  function u(e, t) {
    return c(e, t) || l(e, s);
  }
}
